import React, { useEffect, useState } from "react";
import orciCareLogo from "assets/header-logo-2.jpg";
import placeholderIcon from "assets/placeholder.png";
import scribeLogo from "assets/scribeLogo.png";
import DehazeIcon from "@material-ui/icons/Dehaze";

import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import {
  FormControl,
  Divider,
  IconButton,
  NativeSelect,
  InputBase,
  Badge,
} from "@mui/material";
import {
  useUserData,
  useUpdateUserData,
} from "components/customHooks/userDataContext";
import { locationUpdate } from "apiHandler/actions/auth";
import CheckInOutButton from "components/TimeTracker/CheckInOutButton";
import ApplyLeaveButton from "components/TimeTracker/ApplyLeaveButton";
import { withStyles } from "@mui/styles";
import { Chat, ManageAccounts } from "@mui/icons-material";
import { getNewMessageCount } from "apiHandler/actions";
// import PracticeRedirectPage from "components/PracticeRedirectPage";

// For the Select component
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "#e5e5e5",
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
}))(InputBase);

const HeaderComponent = (props) => {
  const userData = useUserData();
  const setUserData = useUpdateUserData();
  const navigate = useNavigate();

  const location = useLocation();
  const token = userData?.access_token;
  const [totalMessageCount, setTotalMessageCount] = useState(0);
  // const [showPractice, setShowPractice] = useState(false);
  // console.log("USER DATA", userData);

  const changeLocationId = async (id) => {
    const response = await locationUpdate(id, token);
    if (response !== "ERROR") {
      setUserData({ ...userData, current_practice_location_id: parseInt(id) });
    }
  };

  useEffect(() => {
    if (!userData?.selected_practice) return;

    getMessageCount();
  }, [userData?.selected_practice, location.pathname]);

  const getMessageCount = async () => {
    try {
      if (!userData?.selected_practice || !userData?.email) return;

      const payload = {
        practice_id: userData.selected_practice,
        scribe_user_id: userData.email,
      };

      const res = await getNewMessageCount(payload, token);

      if (!Array.isArray(res)) return;

      let total = 0;

      res.forEach((item) => {
        total += item.count || 0;
      });

      setTotalMessageCount(total);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // Scribe Header
  if (userData?.userType === "scribe") {
    const userName = userData.first_name + " " + userData.last_name;
    return (
      <header className="scribe-header">
        <IconButton
          onClick={() => props.setCollapsed(false)}
          className="nav-icon"
        >
          <DehazeIcon fontSize="large" />
        </IconButton>
        <img width={148} height={53} src={scribeLogo} alt="Scribe Logo" />
        <div className="flex">
          <span className="scribe-name">{userName}</span>
          <Divider orientation="vertical" />
          <div style={{ marginTop: 8 }}>
            <IconButton onClick={() => navigate("/main-dashboard")}>
              <HomeIcon fontSize={"small"} />
            </IconButton>
            <IconButton onClick={() => navigate("/scriber-chat")}>
              <Badge badgeContent={totalMessageCount} color="error">
                <Chat fontSize={"small"} />
              </Badge>
            </IconButton>
            <IconButton onClick={() => navigate("/select-practice")}>
              <ManageAccounts fontSize={"small"} />
            </IconButton>
          </div>
        </div>
      </header>
    );
  }
  //clinical header
  if (userData?.userType === "clinical") {
    const userName = userData.first_name + " " + userData.last_name;
    return (
      <header className="scribe-header">
        <IconButton
          onClick={() => props.setCollapsed(false)}
          className="nav-icon"
        >
          <DehazeIcon fontSize="large" />
        </IconButton>
        <img width={148} height={53} src={orciCareLogo} alt="Scribe Logo" />
        <div className="flex">
          <span className="scribe-name">{userName}</span>
          <Divider orientation="vertical" />
          <div style={{ marginTop: 8 }}>
            <IconButton onClick={() => navigate("/main-dashboard")}>
              <HomeIcon fontSize={"small"} />
            </IconButton>
            <IconButton onClick={() => navigate("/select-practice")}>
              <SettingsIcon fontSize={"small"} />
            </IconButton>
            <IconButton onClick={() => navigate("/scriber-chat")}>
              <Badge badgeContent={totalMessageCount} color="error">
                <Chat fontSize={"small"} />
              </Badge>
            </IconButton>
            <IconButton onClick={() => navigate("/select-practice")}>
              <ManageAccounts fontSize={"small"} />
            </IconButton>
          </div>
        </div>
      </header>
    );
  }

  // Admin Header
  if (userData?.userType === "Admin") {
    const userName = userData.first_name + " " + userData.last_name;
    return (
      <header className="admin-header">
        <IconButton
          onClick={() => props.setCollapsed(false)}
          className="nav-icon"
        >
          <DehazeIcon fontSize="large" />
        </IconButton>
        <img width={170} height={46} src={orciCareLogo} alt="Orci Care logo" />
        <div className="flex">
          <span className="scribe-name">{userName}</span>
          <Divider orientation="vertical" />
          <div style={{ marginTop: 8 }}>
            <IconButton onClick={() => navigate("/select-practice")}>
              <ManageAccounts fontSize={"small"} />
            </IconButton>
          </div>

          <div style={{ marginTop: 8 }}>
            <IconButton onClick={() => navigate("/login")}>
              <ExitToAppIcon fontSize={"small"} />
            </IconButton>
          </div>
        </div>
      </header>
    );
  }
  const practice_name = userData?.practices.filter(
    (practice) => practice.practice_id === +userData?.selected_practice,
  )?.[0]?.["practice_name"];
  // Provider Header
  return (
    <header className="provider-header">
      <IconButton
        onClick={() => props.setCollapsed(false)}
        className="nav-icon"
      >
        <DehazeIcon fontSize="large" />
      </IconButton>
      <div className="header-logo">
        <img width={170} height={46} src={orciCareLogo} alt="Orci Care logo" />
      </div>
      <CheckInOutButton />
      <ApplyLeaveButton />
      <div className="provider-header-right">
        {userData?.location && (
          <FormControl
            variant="outlined"
            style={{ marginRight: "25px", marginTop: "8px" }}
          >
            <NativeSelect
              value={parseInt(userData.current_practice_location_id)}
              onChange={(e) => changeLocationId(e.target.value)}
              input={<BootstrapInput />}
            >
              {userData.location.map((l) => (
                <option value={l.locationId} key={l.locationId}>
                  {l.locationName}
                </option>
              ))}
            </NativeSelect>
          </FormControl>
        )}
        <Divider orientation="vertical" flexItem />
        <div className="verticalCenter dr-cont">
          <img
            src={userData?.doctorData?.providerImage || placeholderIcon}
            width={28}
            height={28}
            style={{ marginRight: "10px" }}
            alt=""
          />
          <span className="drName">{practice_name}</span>
        </div>
        <Divider orientation="vertical" flexItem />
        {/* <div className="verticalCenter">
					<Badge badgeContent={0} color="secondary">
						<NotificationsNoneIcon fontSize={"large"} />
					</Badge>
				</div> */}
        <Divider orientation="vertical" flexItem />
        <div className="verticalCenter">
          <IconButton onClick={() => navigate("/dashboard/practice-settings")}>
            <SettingsIcon fontSize={"small"} />
          </IconButton>
          <IconButton onClick={() => navigate("/select-practice")}>
            <ManageAccounts fontSize={"small"} />
          </IconButton>
          <IconButton onClick={() => navigate("/main-dashboard")}>
            <HomeIcon fontSize={"small"} />
          </IconButton>
          <IconButton onClick={() => navigate("/scriber-chat")}>
            <Badge badgeContent={totalMessageCount} color="error">
              <Chat fontSize={"small"} />
            </Badge>
          </IconButton>
        </div>
      </div>
    </header>
  );
};

export default HeaderComponent;
